import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class DispatchCurrCostAdjustmentBus extends BaseBus
{
    constructor(busObj: DispatchCurrCostAdjustmentBus = null) {
        super(busObj);
    }
    CID(): any {
        return this.dispatchCurrentCostAdjustmentId;
    }
    setId(id: any) {
        this.dispatchCurrentCostAdjustmentId;
    }
    setParentId(id: any) {
        this.dispatchId = id;
    }
    initialize(data: DispatchCurrCostAdjustmentBus) {
        super.initialize(data);
        try {
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
        }
        catch {

        }

    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!CommonFunctions.hasValue(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    dispatchCurrentCostAdjustmentId: any;
    //dispatchCurrentCostAdjustmentCodeId: any;
    dispatchId: any;
    personId: any;
    amount: number;
    note: string;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    dispatchCostAdjustmentCode: string;
}
